import { LanguagePreferencesSchema } from './schemas/settingsSchemas.js';
export const defaultLanguagePreferences = LanguagePreferencesSchema.parse({
    preferences: [{ iso6391: 'en', iso6392: 'eng', displayName: 'English' }],
});
//# sourceMappingURL=LanguagePreferences.js.map